(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["fs-cart-confirmation"] && !Shopify.designMode) return;
  try {
    (() => {
  const rootSelector = '[data-fs-purchase-choice]';
  const roots = () => Array.from(document.querySelectorAll(rootSelector));
  const desktopChoice = window.matchMedia('(min-width: 990px)');
  desktopChoice.addEventListener('change', event => {
    roots().forEach(root => {
      const details = root.querySelector('[data-fs-choice-details]');
      if (details) details.open = event.matches;
    });
  });
  const messages = JSON.parse(document.getElementById('fs-choice-messages')?.textContent || '{}');
  const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: window.Shopify?.currency?.active || 'USD' }).format(cents / 100);
  const write = (node, text) => {
    if (!node || node.textContent === text) return;
    if (node.childNodes.length === 1 && node.firstChild.nodeType === 3) node.firstChild.nodeValue = text;
    else node.textContent = text;
  };
  const status = (root, text = '') => {
    const node = root?.querySelector('[data-fs-choice-status]');
    if (!node) return;
    write(node, text);
    node.hidden = !text;
  };
  let pending = false;
  let blocked = false;
  let opening = false;
  let checkoutError = false;
  let feedbackTimer;
  let nativeTimer;
  const checkoutSelector = '[data-fs-cc-checkout], [data-fs-native-checkout]';
  const cartIsUpdating = () => pending || Boolean(window.fsCartModeIsBusy?.()) || Boolean(document.querySelector('#cart-side-drawer [data-cart-item].disabled'));
  const refreshCheckoutFeedback = () => {
    clearTimeout(feedbackTimer);
    const updating = cartIsUpdating();
    const text = updating ? messages.checkout_updating : opening ? messages.checkout_opening : blocked ? messages.checkout_review : checkoutError ? messages.checkout_retry : '';
    document.querySelectorAll(checkoutSelector).forEach(button => {
      const label = button.querySelector(':scope > span');
      if (!label) return;
      if (!button.dataset.fsOriginalLabel) button.dataset.fsOriginalLabel = label.textContent;
      write(label, text || button.dataset.fsOriginalLabel);
      button.setAttribute('aria-busy', updating || opening ? 'true' : 'false');
      button.setAttribute('aria-disabled', updating || opening ? 'true' : 'false');
      label.setAttribute('aria-live', 'polite');
      label.setAttribute('aria-atomic', 'true');
    });
    if (updating) feedbackTimer = setTimeout(refreshCheckoutFeedback, 100);
  };
  window.fsCheckoutFeedback = state => {
    opening = state === 'opening';
    checkoutError = state === 'error';
    status(document.querySelector('[data-fs-cart-confirmation]'), checkoutError ? messages.checkout_error : '');
    refreshCheckoutFeedback();
  };
  const setBusy = value => {
    pending = value;
    document.body.classList.toggle('fs-choice-busy', value);
    document.querySelectorAll(rootSelector + ', [data-fs-cart-confirmation]').forEach(node => {
      node.setAttribute('aria-busy', value ? 'true' : 'false');
    });
    refreshCheckoutFeedback();
  };
  const sync = (root, variant) => {
    if (!root) return;
    const form = document.getElementById(root.dataset.formId);
    const id = variant?.id || form?.querySelector('[name="id"]')?.value || root.dataset.variantId;
    const map = JSON.parse(root.querySelector('[data-fs-choice-variants]').textContent);
    const price = map[id];
    const eligible = Boolean(price && price.insider > 0 && price.insider < price.full);
    root.hidden = !eligible;
    root.closest('[data-price-wrapper]')?.classList.toggle('fs-choice-ready', eligible);
    document.body.classList.toggle('fs-has-pdp-choice', eligible);
    if (!eligible) return;
    const choiceDetails = root.querySelector('[data-fs-choice-details]');
    if (choiceDetails && desktopChoice.matches) choiceDetails.open = true;
    root.dataset.variantId = id;
    write(root.querySelector('[data-fs-option-price="insider"]'), money(price.insider));
    write(root.querySelector('[data-fs-option-price="full_price"]'), money(price.full));
    write(root.querySelector('[data-fs-choice-saving]'), messages.saving + ' ' + money(price.full - price.insider));
    const isFullPrice = root.dataset.mode === 'full_price';
    write(root.querySelector('[data-fs-choice-summary-label]'), isFullPrice ? messages.full_selected : messages.pdp_insider_selected);
    write(root.querySelector('[data-fs-choice-summary-price]'), money(isFullPrice ? price.full : price.insider));
    write(root.querySelector('[data-fs-choice-summary-benefit]'), isFullPrice ? messages.no_membership : messages.benefits);
    const summarySaving = root.querySelector('[data-fs-choice-summary-saving]');
    if (summarySaving) {
      write(summarySaving, messages.saving + ' ' + money(price.full - price.insider));
      summarySaving.hidden = isFullPrice;
    }
    root.querySelector('[data-fs-pdp-terms]').hidden = root.dataset.mode !== 'insider';
    root.querySelectorAll('[data-fs-pdp-option]').forEach(input => { input.checked = input.value === root.dataset.mode; });
    const sticky = form?.closest('.shopify-section')?.querySelector('.sticky-cart');
    sticky?.querySelectorAll('[data-actual-price]').forEach(node => {
      write(node, money(root.dataset.mode === 'full_price' ? price.full : price.insider));
      node.setAttribute('data-price-label', messages[root.dataset.mode]);
    });
  };
  window.fsSyncPurchaseChoice = (section, variant) => {
    const root = section?.querySelector?.(rootSelector);
    if (root) sync(root, variant);
  };
  const idle = async () => {
    const deadline = Date.now() + 15000;
    while (window.fsCartModeIsBusy?.()) {
      if (Date.now() > deadline) throw new Error('Cart update timeout');
      await new Promise(resolve => setTimeout(resolve, 50));
    }
  };
  const confirmMode = async mode => {
    await idle();
    const path = (window.Shopify?.routes?.root || '/') + 'cart.js';
    const response = await fetch(path, { headers: { Accept: 'application/json' }, cache: 'no-store' });
    if (!response.ok) throw new Error('Cart unavailable');
    let cart = await response.json();
    if ((cart.attributes?.pricing_mode || 'insider') !== mode) {
      if (!window.fsApplyMode) throw new Error('Pricing not ready');
      cart = await window.fsApplyMode(mode, cart);
      if (!cart || cart.attributes?.pricing_mode !== mode) throw new Error('Pricing update failed');
    }
    if (window.FS_INSIDER) window.FS_INSIDER.mode = mode;
    return cart;
  };
  window.fsPreparePurchaseChoice = async (form, root) => {
    if (root.hidden) return;
    if (pending) throw new Error('Cart busy');
    setBusy(true);
    status(root, messages.updating);
    await confirmMode(root.dataset.mode);
    blocked = false;
  };
  window.fsFinishPurchaseChoice = (form, root, error) => {
    if (error) { blocked = true; status(root, messages.error); }
    else if (root.querySelector('[data-fs-choice-status]')?.textContent === messages.updating) status(root);
    setBusy(false);
  };
  document.addEventListener('change', event => {
    const input = event.target.closest('[data-fs-pdp-option]');
    if (!input) return;
    const root = input.closest(rootSelector);
    root.dataset.mode = input.value;
    root.dataset.dirty = 'true';
    sync(root, { id: root.dataset.variantId });
    status(root);
    const details = root.querySelector('[data-fs-choice-details]');
    if (details && !desktopChoice.matches) {
      details.open = false;
      details.querySelector('summary')?.focus({ preventScroll: true });
    }
  });
  document.addEventListener('click', async event => {
    if (event.target.closest('#cart-side-drawer [data-quantity-increment], #cart-side-drawer [data-quantity-decrement], #cart-side-drawer [data-remove-item]')) setTimeout(refreshCheckoutFeedback, 0);
    const checkout = event.target.closest(checkoutSelector);
    if (checkout && opening) {
      event.preventDefault();
      event.stopImmediatePropagation();
      return;
    }
    if (checkout && (cartIsUpdating() || blocked)) {
      event.preventDefault();
      event.stopImmediatePropagation();
      const panel = document.querySelector('[data-fs-cart-confirmation]');
      status(panel, cartIsUpdating() ? messages.updating : messages.error);
      refreshCheckoutFeedback();
      return;
    }
    if (checkout?.matches('[data-fs-native-checkout]')) {
      window.fsCheckoutFeedback('opening');
      clearTimeout(nativeTimer);
      nativeTimer = setTimeout(() => window.fsCheckoutFeedback('error'), 15000);
    }
    const button = event.target.closest('#cart-side-drawer [data-fs-mode]');
    if (!button || !button.closest('[data-fs-cart-confirmation]')) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (pending) return;
    const mode = button.dataset.fsMode;
    const oldPanel = button.closest('[data-fs-cart-confirmation]');
    setBusy(true);
    status(oldPanel, messages.updating);
    try {
      await confirmMode(mode);
      blocked = false;
      roots().forEach(root => { root.dataset.mode = mode; delete root.dataset.dirty; sync(root); });
      const panel = document.querySelector('[data-fs-cart-confirmation]');
      panel?.querySelector('details')?.removeAttribute('open');
      status(panel);
    } catch (error) {
      blocked = true;
      status(document.querySelector('[data-fs-cart-confirmation]'), messages.error);
    } finally { setBusy(false); }
  }, true);
  document.addEventListener('submit', event => {
    if (event.target.matches('[data-cart-form]') && (cartIsUpdating() || blocked)) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);
  window.addEventListener('pageshow', () => {
    clearTimeout(nativeTimer);
    opening = false;
    checkoutError = false;
    refreshCheckoutFeedback();
  });
  const init = () => { roots().forEach(root => sync(root)); refreshCheckoutFeedback(); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', init);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["fs-cart-page-choice"] && !Shopify.designMode) return;
  try {
    (() => {
  let busy = false;
  const idle = async () => {
    const deadline = Date.now() + 15000;
    while (window.fsCartModeIsBusy?.()) {
      if (Date.now() > deadline) throw new Error('Cart update timeout');
      await new Promise(resolve => setTimeout(resolve, 50));
    }
  };
  document.addEventListener('click', async event => {
    const button = event.target.closest?.('[data-fs-page-mode]');
    if (!button) return;
    event.preventDefault();
    if (busy || button.getAttribute('aria-pressed') === 'true') return;
    const root = button.closest('[data-fs-cart-page-choice]');
    const status = root?.querySelector('[data-fs-page-mode-status]');
    const say = (text, isError) => {
      if (!status) return;
      status.textContent = text;
      status.hidden = !text;
      status.classList.toggle('is-error', Boolean(isError));
    };
    const mode = button.dataset.fsPageMode;
    busy = true;
    root?.setAttribute('aria-busy', 'true');
    say(root?.dataset.updating || '');
    try {
      if (!window.fsApplyMode) throw new Error('Pricing not ready');
      await idle();
      const cart = await window.fsApplyMode(mode);
      if (!cart || cart.attributes?.pricing_mode !== mode) throw new Error('Pricing update failed');
      window.location.reload();
    } catch (error) {
      console.error('[fs] cart page mode switch failed', error);
      busy = false;
      root?.removeAttribute('aria-busy');
      say(root?.dataset.error || '', true);
    }
  });
})();
  } catch(e) { console.error(e); }
})();

})();
